/// <amd-module name="Environments/RunsCommon/Linking" />
import { ITfsPageService } from "Tfs/Platform/Page";

import { IVssPageContext } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";

// Copied selectively from Tfs\Web\extensions\build\vss-build-web\common\client\Linking.ts

export namespace NavConstants {
    export const job = "j";
}

export namespace RouteParameters {
    export const BuildId = "buildId";
    export const Project = "project";
    export const Team = "team";
    export const View = "view";
}

export function getBuildUrl(pageContext: IVssPageContext, buildId: number, additionalRouteValues?: { [key: string]: string }): string {
    const routeValues: { [key: string]: string } = {};
    _initializeRouteValues(pageContext, routeValues);

    routeValues[RouteParameters.BuildId] = buildId + "";

    let url = routeUrl(pageContext, "ms.vss-build-web.ci-results-hub-route", routeValues);
    url += `&${RouteParameters.View}=logs`;

    if (additionalRouteValues) {
        Object.keys(additionalRouteValues).forEach((key) => {
            const value = additionalRouteValues[key];
            if (value) {
                url += `&${key}=${additionalRouteValues[key]}`;
            }
        });
    }

    return url;
}

function _initializeRouteValues(pageContext:IVssPageContext, routeValues: { [key: string]: string }) {
    let projectName: string = "";
    let teamName: string = "";

    const tfsPageService = pageContext.getService<ITfsPageService>("ITfsPageService");
    const tfsPageData = tfsPageService.getData();
    if (tfsPageData) {
        if (!projectName && tfsPageData.project) {
            projectName = tfsPageData.project.name;
        }
        const teamData = tfsPageService.getHorizontalNavigationTeamData();
        if (!teamName && teamData) {
            teamName = teamData.name;
        }
    }

    if (projectName) {
        routeValues[RouteParameters.Project] = projectName;
    }

    if (teamName) {
        routeValues[RouteParameters.Team] = teamName;
    }
}
